import { getIsNullish } from '../../jsUtils';

export const getNumberWithSignView = (value?: number | null): string | null => {
  if (getIsNullish(value)) {
    return null;
  }
  const formatter = new Intl.NumberFormat('en-US', {
    signDisplay: 'exceptZero',
    useGrouping: false,
  });

  return formatter.format(value);
};
